// this file is automatically generated by git.version.sh script
export const version = {version: '2025.9.0', revision_short: '6cd0e08e8', revision: '6cd0e08e8f7c0a81a16e0d21157ade878da87e95', branch: 'release/2025.9', date: '2026-10-12 11:48:54 +0300'};
